/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const ON_SUBMIT_TRUE = 'boilerplate/UploadPage/ON_SUBMIT_TRUE';
export const SET_PROCESS_COUNT = 'boilerplate/UploadPage/SET_PROCESS_COUNT';
export const SET_ERR_COUNT = 'boilderplate/UploadPage/SET_ERR_COUNT';
export const LOADER_STATUS = 'boilderplate/UploadPage/LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/UploadPage/PROFILE_INFO';
export const SUPPLIER_INFO = 'boilerplate/UploadPage/SUPPLIER_INFO';
export const SET_TOTAL_RECORD = 'boilerplate/GSTR1_UploadPage/SET_TOTAL_RECORD'
export const SET_TABLE_DATA = 'gstr1/SET_TABLE_DATA';
